import React from "react";
import { AppUser } from "./appUser";

/*interface IAppUserContextProps{
    appUser:AppUser
}*/
//const AppUserContext = React.createContext<IAppUserContextProps|undefined>(undefined);
const AppUserContext = React.createContext<AppUser>(new AppUser());
//export const AppUserContextProvider = AppUserContext.Provider;
//export const AppUserCOntextConsumer = AppUserContext.Consumer;

export default AppUserContext;